module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1023-a63002aa6c14aa77e0a9ddb53aa75f36.png";